//文字コードはutf-8

/* ハンバーガーメニュー（SP slide-in panel）
========================================================*/
import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initHamburgerMenu() {
    const navList = document.querySelector('.header__nav__list');
    const openBtn = document.querySelector('.openbtn');
    if (!navList || !openBtn) return;

    const mq = window.matchMedia(MEDIA_QUERIES.sp_x_tablet);

    // Inject "menu" text into openbtn
    const btnText = document.createElement('span');
    btnText.className = 'openbtn__text';
    btnText.textContent = 'menu';
    openBtn.appendChild(btnText);

    // Create backdrop overlay
    const overlay = document.createElement('div');
    overlay.className = 'headerOverlay';
    document.body.appendChild(overlay);

    function openMenu() {
        openBtn.classList.add('active');
        openBtn.setAttribute('aria-expanded', 'true');
        navList.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        btnText.textContent = 'close';
    }

    function closeMenu() {
        openBtn.classList.remove('active');
        openBtn.setAttribute('aria-expanded', 'false');
        navList.classList.remove('is-open');
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
        btnText.textContent = 'menu';
        // Close all open accordion lists
        navList.querySelectorAll('.item__dropdown__title.is-open').forEach(function (title) {
            title.classList.remove('is-open');
        });
        $(navList).find('.item__dropdown__list').slideUp(300);
    }

    openBtn.addEventListener('click', function () {
        if (navList.classList.contains('is-open')) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    overlay.addEventListener('click', closeMenu);

    // SP accordion: click item__dropdown__title to slideToggle item__dropdown__list
    var titles = navList.querySelectorAll('.item__dropdown__title');
    titles.forEach(function (title) {
        title.addEventListener('click', function () {
            if (!mq.matches) return;

            var $inner = $(title).closest('.item__dropdown__inner');
            var $list = $inner.find('> .item__dropdown__list');
            if (!$list.length) return;

            var isOpen = title.classList.contains('is-open');

            // Close all other open accordions
            titles.forEach(function (other) {
                if (other !== title && other.classList.contains('is-open')) {
                    other.classList.remove('is-open');
                    $(other).closest('.item__dropdown__inner')
                        .find('> .item__dropdown__list')
                        .slideUp(300);
                }
            });

            // Toggle current
            if (isOpen) {
                title.classList.remove('is-open');
                $list.slideUp(300);
            } else {
                title.classList.add('is-open');
                $list.slideDown(300);
            }
        });
    });

    // Close on resize to PC
    mq.addEventListener('change', function (e) {
        if (!e.matches) {
            closeMenu();
            // Reset inline styles from slideToggle
            $(navList).find('.item__dropdown__list').removeAttr('style');
        }
    });
}
